import { defineComponent as p, openBlock as t, createElementBlock as a, mergeProps as u, unref as o, renderSlot as V, createElementVNode as e, createCommentVNode as H } from "vue";
import { useScalarIcon as L } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, m = { key: 1 }, f = { key: 2 }, A = { key: 3 }, h = { key: 4 }, k = { key: 5 }, v = {
  name: "ScalarIconChartLine"
}, w = /* @__PURE__ */ p({
  ...v,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = L(s);
    return (i, l) => (t(), a("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      V(i.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", g, l[0] || (l[0] = [
        e("path", { d: "M236,208a12,12,0,0,1-12,12H32a12,12,0,0,1-12-12V48a12,12,0,0,1,24,0v85.55L88.1,95a12,12,0,0,1,15.1-.57l56.22,42.16L216.1,87A12,12,0,1,1,231.9,105l-64,56a12,12,0,0,1-15.1.57L96.58,119.44,44,165.45V196H224A12,12,0,0,1,236,208Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", m, l[1] || (l[1] = [
        e("path", {
          d: "M224,64V208H32V48H208A16,16,0,0,1,224,64Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0v94.37L90.73,98a8,8,0,0,1,10.07-.38l58.81,44.11L218.73,90a8,8,0,1,1,10.54,12l-64,56a8,8,0,0,1-10.07.38L96.39,114.29,40,163.63V200H224A8,8,0,0,1,232,208Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", f, l[2] || (l[2] = [
        e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM200,176a8,8,0,0,1,0,16H56a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v62.92l34.88-29.07a8,8,0,0,1,9.56-.51l43,28.69,43.41-36.18a8,8,0,0,1,10.24,12.3l-48,40a8,8,0,0,1-9.56.51l-43-28.69L64,155.75V176Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", A, l[3] || (l[3] = [
        e("path", { d: "M230,208a6,6,0,0,1-6,6H32a6,6,0,0,1-6-6V48a6,6,0,0,1,12,0v98.78l54.05-47.3a6,6,0,0,1,7.55-.28l60.11,45.08,60.34-52.8a6,6,0,0,1,7.9,9l-64,56a6,6,0,0,1-7.55.28L96.29,111.72,38,162.72V202H224A6,6,0,0,1,230,208Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", h, l[4] || (l[4] = [
        e("path", { d: "M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0v94.37L90.73,98a8,8,0,0,1,10.07-.38l58.81,44.11L218.73,90a8,8,0,1,1,10.54,12l-64,56a8,8,0,0,1-10.07.38L96.39,114.29,40,163.63V200H224A8,8,0,0,1,232,208Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", k, l[5] || (l[5] = [
        e("path", { d: "M228,208a4,4,0,0,1-4,4H32a4,4,0,0,1-4-4V48a4,4,0,0,1,8,0V151.19L93.37,101a4,4,0,0,1,5-.19l61.41,46.05L221.37,93a4,4,0,0,1,5.26,6l-64,56a4,4,0,0,1-5,.19l-61.41-46L36,161.81V204H224A4,4,0,0,1,228,208Z" }, null, -1)
      ]))) : H("", !0)
    ], 16));
  }
});
export {
  w as default
};
